import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

import { UIModal, UIIcon } from "../../ui";
import messages from "../../../assets/locale/messages";

/**
 * Confirmation dialog for withdrawing a pending company profile edit request.
 */
const CancelEditRequestModal = ({ open, onClose, onConfirm, submitting }) => {
  const lang = useSelector((state) => state.locale.lang);
  const { shared } = messages[lang];
  const copy = shared?.editRequestBanner?.cancelConfirmDialog;

  return (
    <UIModal
      open={open}
      type="destructive"
      title={copy?.title}
      description={copy?.message}
      icon={
        <UIIcon
          name="alertCircle"
          width={36}
          height={36}
          color="currentColor"
          strokeWidth={3.11}
          decorative
        />
      }
      onClose={onClose}
      onCancel={onClose}
      onConfirm={onConfirm}
      cancelLabel={copy?.no}
      confirmLabel={copy?.yes}
      maxWidth="xs"
      fullWidth
      showClose={false}
      disableEscapeKeyDown={submitting}
      cancelButtonProps={{ disabled: submitting }}
      confirmButtonProps={{ disabled: submitting, loading: submitting }}
    />
  );
};

CancelEditRequestModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  submitting: PropTypes.bool,
};

CancelEditRequestModal.defaultProps = {
  submitting: false,
};

export default CancelEditRequestModal;
